




































import {Vue, Component} from "vue-property-decorator";
import ModalWindow from "@/views/ModalWindow.vue"
import GreenButton from "@/views/GreenButton.vue"
import FileInput from "@/views/FileInput.vue"

@Component({
    components: {
        ModalWindow,
        GreenButton,
        FileInput,
    }
})
export default class Feedback extends Vue {
    private name = ''
    private email = ''
    private message = {
        text: '',
        maxlength: 2000,
    }
    private fileName: string | null = null
    private file!: File
    private errorMessage = ''
    private submitted = false
    private sendingInProgress = false

    get isError() {
        return this.errorMessage !== '';
    }

    get isSent() {
        return this.submitted;
    }

    private setError(errorCode: string) {
        this.errorMessage = errorCode;
    }

    private clearError() {
        this.sendingInProgress = false
        this.errorMessage = ''
    }

    private handleFileUpload(file: File | null) {
        if (file != null && this.checkFile(file)) {
            this.file = file
            this.fileName = this.file.name
        } else {
            this.fileName = null
        }
    }

    private checkFile(file: File) {
        if (this.checkFileSize(file)) {
            this.clearError()
            return true
        }

        return false
    }

    private checkFileSize(file: File) {
        if (file.size < 1 || file.size > 10485760) {
            this.setError('BadSize')

            return false
        }

        return true
    }

    private sendFeedback() {
        this.sendingInProgress = true
        const formData = new FormData()
        formData.append('name', this.name)
        formData.append('email', this.email)
        formData.append('message', this.message.text)
        if (this.file) {
            formData.append('file', this.file)
        }
        const requestOptions = {
            method: "POST",
            body: formData
        }

        fetch(process.env.VUE_APP_API_HOST + '/feedback', requestOptions)
            .then(response => {
                    if (!response.ok) throw Error(response.statusText)
                    this.submitted = true
                }
            )
            .catch(() => this.setError('DefaultErrorMessage'))
    }
}
